/**
 * Assignment Board Block - Frontend JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {
    initializeAssignmentBoards();
});

function initializeAssignmentBoards() {
    const boards = document.querySelectorAll('.wp-block-xtra-assignment-board');
    
    boards.forEach(board => {
        if (board.dataset.initialized) return;
        board.dataset.initialized = 'true';
        
        // Initialize claim buttons
        const claimButtons = board.querySelectorAll('.assignment-claim');
        claimButtons.forEach(button => {
            button.addEventListener('click', handleClaim);
        });
        
        // Initialize view details buttons
        const detailButtons = board.querySelectorAll('.assignment-view-details');
        detailButtons.forEach(button => {
            button.addEventListener('click', handleViewDetails);
        });
        
        // Initialize modal close
        const modal = document.getElementById('assignment-details-modal');
        if (modal) {
            const closeBtn = modal.querySelector('.xtra-modal-close');
            closeBtn.addEventListener('click', () => {
                modal.style.display = 'none';
            });
            
            // Close on outside click
            window.addEventListener('click', (event) => {
                if (event.target === modal) {
                    modal.style.display = 'none';
                }
            });
        }
    });
}

async function handleClaim(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const assignmentId = button.dataset.assignmentId;
    
    if (!assignmentId) return;
    
    // Disable button and show loading state
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Claiming...';
    
    try {
        const response = await fetch(`/wp-json/xtraxtra-assignments/v1/assignments/${assignmentId}/claim`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-WP-Nonce': window.XXRest?.nonce || ''
            },
            credentials: 'same-origin'
        });
        
        const data = await response.json();
        
        if (!response.ok) {
            throw new Error(data.error || 'Failed to claim assignment');
        }
        
        // Success - update UI
        showNotification('Assignment claimed successfully.', 'success');
        
        // Remove the assignment card with animation
        const card = button.closest('.assignment-card');
        if (card) {
            // Animate out
            card.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
            card.style.opacity = '0';
            card.style.transform = 'scale(0.95)';
            
            // Remove after animation
            setTimeout(() => {
                card.remove();
                
                // Check if no assignments left
                const board = document.querySelector('.wp-block-xtra-assignment-board');
                const remainingCards = board?.querySelectorAll('.assignment-card');
                if (remainingCards && remainingCards.length === 0) {
                    const grid = board.querySelector('.assignments-grid');
                    if (grid) {
                        grid.innerHTML = '<div class="no-assignments"><p>No available assignments at this time.</p></div>';
                    }
                }
            }, 300);
            
            // Update claim count
            updateClaimCount();
        }
        
    } catch (error) {
        console.error('Claim error:', error);
        showNotification(error.message || 'Failed to claim assignment', 'error');
        
        // Reset button
        button.disabled = false;
        button.textContent = originalText;
    }
}

async function handleViewDetails(e) {
    e.preventDefault();
    const button = e.currentTarget;
    const assignmentId = button.dataset.assignmentId;
    
    if (!assignmentId) return;
    
    // Get the assignment card for basic info
    const card = button.closest('.assignment-card');
    const title = card.querySelector('.assignment-title').textContent;
    const details = card.querySelector('.assignment-details').innerHTML;
    
    // Get the modal
    const modal = document.getElementById('assignment-details-modal');
    if (!modal) return;
    
    const modalTitle = modal.querySelector('.modal-title');
    const modalBody = modal.querySelector('.modal-body');
    
    // Set title and show loading
    modalTitle.textContent = title;
    modalBody.innerHTML = '<p style="text-align: center; padding: 40px;">Loading assignment details...</p>';
    modal.style.display = 'block';
    
    try {
        // Fetch full post content from WordPress API
        const response = await fetch(`/wp-json/wp/v2/xtra-assignments/${assignmentId}`);
        if (!response.ok) throw new Error('Failed to load assignment details');
        
        const post = await response.json();
        
        // Populate modal with full content
        modalBody.innerHTML = `
            <div class="assignment-full-content">
                ${post.content.rendered || '<p>No detailed description available.</p>'}
            </div>
            <div class="assignment-meta-details">
                <h3>Assignment Details</h3>
                <div class="meta-details-grid">
                    ${details}
                </div>
            </div>
            <div class="assignment-instructions">
                <h3>How to Complete</h3>
                <ol>
                    <li>Click "Claim Assignment" to reserve this assignment</li>
                    <li>Write your article according to the requirements</li>
                    <li>Submit your completed work before the deadline</li>
                    <li>An editor will review your story</li>
                    <li>Receive your MyBucks bonus upon approval</li>
                </ol>
            </div>
        `;
    } catch (error) {
        console.error('Error loading assignment details:', error);
        // If API fails, use the excerpt from the card as fallback
        const excerpt = card.querySelector('.assignment-excerpt').innerHTML;
        modalBody.innerHTML = `
            <div class="assignment-full-content">
                ${excerpt}
                <p style="color: #999; font-style: italic; margin-top: 1rem;">Full details could not be loaded. Please try refreshing the page.</p>
            </div>
            <div class="assignment-meta-details">
                <h3>Assignment Details</h3>
                <div class="meta-details-grid">
                    ${details}
                </div>
            </div>
            <div class="assignment-instructions">
                <h3>How to Complete</h3>
                <ol>
                    <li>Click "Claim Assignment" to reserve this assignment</li>
                    <li>Write your article according to the requirements</li>
                    <li>Submit your completed work before the deadline</li>
                    <li>An editor will review your story</li>
                    <li>Receive your MyBucks bonus upon approval</li>
                </ol>
            </div>
        `;
    }
}

function updateClaimCount() {
    const statusElement = document.querySelector('.claim-status p');
    const claimStatusContainer = document.querySelector('.claim-status');
    
    if (statusElement) {
        const text = statusElement.textContent;
        const match = text.match(/(\d+) of (\d+)/);
        if (match) {
            const current = parseInt(match[1]);
            const limit = parseInt(match[2]);
            const newCount = current + 1;
            
            statusElement.textContent = text.replace(match[0], `${newCount} of ${limit}`);
            
            // Add "View My Assignments" link if going from 0 to 1 claim
            if (current === 0 && newCount === 1 && claimStatusContainer) {
                const existingLink = claimStatusContainer.querySelector('.view-assignments-link');
                if (!existingLink) {
                    const link = document.createElement('a');
                    link.href = '/my-assignments';
                    link.className = 'view-assignments-link';
                    link.textContent = 'View My Assignments';
                    claimStatusContainer.appendChild(link);
                }
            }
            
            // Disable all claim buttons if limit reached
            if (newCount >= limit) {
                const claimButtons = document.querySelectorAll('.assignment-claim:not([disabled])');
                claimButtons.forEach(btn => {
                    btn.disabled = true;
                    btn.textContent = 'Claim Limit Reached';
                });
            }
        }
    }
}

function showNotification(message, type = 'info') {
    // Use XtraXtra toast notifications if available
    if (window.XtraXtraToast && typeof window.XtraXtraToast.show === 'function') {
        window.XtraXtraToast.show(message, type);
        return;
    }
    
    // Fallback: dispatch custom event for toast system
    const event = new CustomEvent('xtraxtra:notify', {
        detail: { message, type }
    });
    document.dispatchEvent(event);
    
    // Final fallback to console
    console.log(`[${type}] ${message}`);
}